<template>
  <div class="charge-detail">
    <div class="main">
      <div class="list">
        <div class="name-label">设备编号：</div>
        <div class="value-label">{{ deviceInfo.primaryDeviceNo }}</div>
        <div class="name-label">设备二维码：</div>
        <div class="value-label" style="width: 3%">{{ deviceInfo.qrcodeBindStatus == 1 ? '已绑定' : '未绑定' }}</div>

        <el-upload
          class="value-label"
          style="width: 80px"
          action=""
          accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF,.BMP,.PDF"
          :show-file-list="false"
          :auto-upload="false"
          :on-change="bindQrcode">
          <div class="ml10" style="color: #67aa42;width: 100%">
            {{ deviceInfo.qrcodeBindStatus == 1 ? '更换二维码' : '绑定二维码' }}
          </div>

        </el-upload>
        <el-button class="value-label"
                   v-if="deviceInfo.qrcodeBindStatus == 1" type="text"
                   style="color: #67aa42;width:70px"
                   @click="getQrcodeSrc">查看二维码
        </el-button>

        <div class="name-label">通讯板编号：</div>
        <div class="value-label">{{ deviceInfo.communicationBoardNo }}</div>
        <div class="name-label">设备类型：</div>
        <div class="value-label">{{ deviceInfo.type }}</div>
      </div>
      <div class="list">
        <div class="name-label">设备名称：</div>
        <div class="value-label">{{ deviceInfo.deviceName }}</div>
        <!-- <div class="name-label">设备通电状态：</div> -->
        <!-- <div class="value-label">{{deviceInfo.primaryDeviceChargeStatus}}</div> -->
        <div class="name-label">设备服务状态：</div>
        <div class="value-label" style="width: 182px">
          {{ deviceInfo.enableStatus == 1 ? '启用' : (deviceInfo.enableStatus == 0 ? '停用' : '') }}
        </div>
        <div class="name-label">投放地址：</div>
        <div class="value-label" style="width:18%;max-width: 19%">{{ deviceInfo.showPlacingPosition }}</div>
        <div class="name-label">定位地址：</div>
        <div class="value-label">{{ deviceInfo.location }}</div>

        <!-- <div class="name-label">版本：</div>
        <div class="value-label">{{deviceInfo.version?versionMap[deviceInfo.version]:""}}</div> -->
      </div>
      <!-- <div class="list"> -->
      <!-- <div class="name-label">已使用电量：</div> -->
      <!-- <div class="value-label">{{deviceInfo.useElectricityDegree}}</div> -->
      <!-- </div> -->

      <div class="list">
        <div class="blue-btn" @click="onQueryBtnClick(deviceInfo.primaryDeviceNo)">查看设备快照</div>
        <div class="blue-btn ml10" style="width: 100px" @click="onQueryRecordClick(deviceInfo.primaryDeviceNo)">
          查看发送请求记录
        </div>
      </div>
      <table class="table-custom">
        <thead>
        <tr>
          <th>端口编号</th>
          <th>端口状态</th>
          <th>端口电流
            <!-- <br/>/电压 -->
          </th>
          <th>端口服务状态</th>
          <!-- <th>端口已充电量<br/> -->
          <!-- <th>充电时长</th> -->
          <th>柜门<br/>状态</th>
          <th>充电器连接状态</th>
          <th>继电器状态</th>
          <th>温度</th>
          <th>温度阀值<br>电流阀值</th>
          <th width="80px">刷新时间</th>
          <th width="116px">操作</th>
        </tr>
        </thead>
        <tbody v-if="dataList.length>0">
        <tr v-for="item,index in dataList" :key="index">
          <td>{{ item.chargePortSeqNo }}</td>
          <td>{{ item.status }}</td>
          <td>电流：{{ item.electricCurrent }}
            <!-- <br/>电压：{{item.electricVoltage}} -->
          </td>

          <td>{{ item.enableStatus }}
            <span v-show="item.enableStatus == '停用'">({{ item.remark }})</span> <br/>
            <div class="text-btn mt4" @click="changeStatus(item)">切换状态</div>
          </td>
          <!-- <td>{{item.electricityCostDegree}}</td> -->
          <!-- <td>{{item.chargeTimeLength>=0?item.chargeTimeLength+"分钟":"--"}}</td> -->
          <td>{{ item.doorStatus }}</td>
          <!-- 充电器连接状态 -->
          <td>{{ item.chargerConnectStatus == 0 ? '未连接' : '已连接' }}</td>
          <!-- 继电器状态 -->
          <td>{{ item.relayConnectStatus == 0 ? '未连接' : '已连接' }}</td>
          <td>{{ item.temperature }}</td>
          <td>温度：{{ item.temperatureThreshold }}<span v-if="item.temperatureThreshold">℃</span>
            <br>电流：{{ item.currentThreshold }}<span v-if="item.currentThreshold">A</span>
          </td>
          <td>{{ item.updateTime }}</td>
          <td>
            <div class="text-btn" @click="onOpenDoorClick(item)">开门</div>
            <div class="text-btn" @click="onRefreshBtnClick(item)">刷新</div>
            <!-- <div class="text-btn mt4" @click="onPowerOnBtnClick(item)">通电</div>
            <div class="text-btn mt4" @click="onPowerOffBtnClick(item)">断电</div> -->
          </td>
        </tr>
        </tbody>
        <tbody v-else>
        <tr>
          <td colspan="9">暂无数据</td>
        </tr>
        </tbody>
      </table>
      <div class="page-box">
        <div class="pre-btn" @click="onPreBtnClick">上一页</div>
        <div class="next-btn" @click="onNextBtnClick">下一页</div>
      </div>
    </div>
    <el-dialog
      title="请输入停用原因"
      :visible.sync="dialogVisible"
      width="30%">
      <el-input type="textarea" :rows="2" placeholder="请输入停用原因" v-model="serviceUnableReason"></el-input>
      <span slot="footer" class="dialog-footer">
          <el-button @click="oncancelBtnClick">取 消</el-button>
          <el-button type="primary" @click="onConfirmBtnClick">确 定</el-button>
          </span>
    </el-dialog>
    <el-dialog title="查看二维码" :visible.sync="qrcodeDialogVisible" width="30%">
      <el-image :src="qrcodeSrc"></el-image>
      <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="qrcodeDialogVisible = false">确 定</el-button>
        </span>
    </el-dialog>

  </div>
</template>
<script>
import Utils from "../../utils/utils";

export default {
  name: 'chargeCabinetMgmtDetailView',
  props: {
    editData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      qrcodeDialogVisible: false,
      deviceInfo: {},
      supportBatteryVoltageList: '',
      versionMap: {
        "1": "v1.0",
        "2": "v2.0",
        "3": "v3.0",
        "4": "v3.1",
        "5": "v4.0"
      },
      operateMap: {
        1: '已通电',
        2: '已断电'
      },
      primaryDeviceNo: '',
      qrCode: '',
      preBtnDisabled: true,
      nextBtnDisabled: false,
      dialogVisible: false,
      editChargePortNo: '',
      serviceUnableReason: '',
      dataList: [],
      curPage: 0,
      dataListTotal: [],

    }
  },
  watch: {
    editData: {
      handler() {
        this.primaryDeviceNo = this.editData.primaryDeviceNo;
        this.queryChargeDetail();
      },
      deep: true,
    },
  },
  mounted() {
  },
  methods: {
    watchCode() {
      this.queryChargeDetail();
      const params = {};
      this.$http
        .post(
          "/managementPlatform/electricity/queryQrCode",
          this.$qs.stringify(params)
        )
        .then(function (res) {
          self.qrcodeSrc = res.mdata['qrCode:']
        })
    },
    // 获得link,从而获得二维码
    queryChargeDetail() {
      let self = this;
      let params = {
        primaryDeviceNo: this.primaryDeviceNo
      };
      this.$http.post('/managementPlatform/electricity/wholeDeviceInfo', this.$qs.stringify(params)).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message || "查询失败!",
            center: true
          });
          return;
        }
        console.log(res, 'res');
        self.deviceInfo = res.mdata.deviceInfo;
        self.dataListTotal = res.mdata.deviceInfo.chargePortList;
        self.showData();
        // if(res.mdata.deviceInfo.link){
        //     self.getQrcodeSrc(res.mdata.deviceInfo.link);
        // }
      }).catch(function (response) {
        console.log(response);
      });
    },
    // 获取二维码
    getQrcodeSrc() {
      let self = this;
      let params = {
        link: self.deviceInfo.link
      }
      this.$http
        .post(
          "/managementPlatform/electricity/queryQrCode",
          this.$qs.stringify(params)
        )
        .then(function (response) {
          let res = response.data;
          console.log(res, '二维码');
          if (!res || !res.result) {
            return;
          }
          self.qrcodeSrc = res.mdata['qrCode:']
          self.qrcodeDialogVisible = true;

        })
        .catch(function (response) {
          console.log(response);
        });
    },
    showData() {
      this.dataList = [];
      for (let i = this.curPage * 5; i < (this.curPage + 1) * 5; i++) {
        if (this.dataListTotal[i]) {
          this.dataList.push(this.dataListTotal[i]);
        }
      }
      console.log(this.dataList, 'dataList');
    },
    onPreBtnClick() {
      if (this.curPage == 0) {
        return;
        // this.curPage=0;
        // this.showData();
        // this.preBtnDisabled=true;
        // this.nextBtnDisabled=true;
      }
      this.curPage--;
      this.showData();
    },
    onNextBtnClick() {
      if (this.curPage == 2) {
        return;
      }
      this.curPage++;
      this.showData();
      // if(this.curPage==0){
      //     this.curPage=1;
      //     this.showData();
      //     this.preBtnDisabled=true;
      //     this.nextBtnDisabled=true;
      // }
    },
    cancelHandle() {
      this.view = 'list';
    },
    bindQrcode(file) {
      let url = URL.createObjectURL(file.raw);
      this.$qrcode.decodeFromImage(url).then((res) => {
        this.qrCode = Utils.getQueryParam(res.data, 'qrcode');
        this.bindQrCodeToDevice();
      });
    },
    bindQrCodeToDevice() {
      let self = this;
      let params = {
        cabinetNo: this.deviceInfo.primaryDeviceNo,
        qrcode: this.qrCode,
        reconfirm: 0
      };
      this.$http.post('/managementPlatform/electricity/bindQRCode', this.$qs.stringify(params)
      ).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message,
            center: true
          });
          return;
        }
        if (res.mdata.needReconfirm == 1) {
          self.$confirm(res.mdata.msg, '', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            self.reconfirm = 1;
            self.bindQrCodeToDevice();
          }).catch(action => {
          });
        } else {
          self.$message({
            type: "success",
            message: "绑定成功!",
            center: true
          });
          self.deviceInfo.qrcodeBindStatus = '1';
        }
      }).catch(function (response) {
        console.log(response);
      });
    },
    changeStatus(item) {
      let self = this;
      this.editChargePortNo = item.chargePortNo;
      if (item.enableStatusCode == 1) {
        this.dialogVisible = true;
      } else {
        this.$confirm('确定启用该端口？', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          self.changePortStatus(1);
        }).catch(action => {
        });
      }
    },
    oncancelBtnClick() {
      this.dialogVisible = false;
      this.serviceUnableReason = '';
    },
    onConfirmBtnClick() {
      let self = this;
      this.$confirm('确定停用该端口？', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        self.dialogVisible = false;
        self.changePortStatus(0, this.serviceUnableReason);
      }).catch(action => {
      });
    },
    changePortStatus(status, reason) {
      let self = this;
      let params = {
        enableStatus: status,
        chargePortNo: this.editChargePortNo
      }
      if (reason) {
        params.serviceUnableReason = reason;
      }
      this.$http.post('/managementPlatform/electricity/editChargePortEnableStatus', this.$qs.stringify(params)
      ).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message,
            center: true
          });
          return;
        }
        self.$message({
          type: "success",
          message: "操作成功!",
          center: true
        });
        self.queryChargeDetail();
      }).catch(function (response) {
        console.log(response);
      });
    },
    onQueryBtnClick(data) {
      let searchCondition = this.editData.searchCondition;
      this.$router.push("/managePage/snapShot?primaryDeviceNo=" + data + "&type=2&searchCondition=" + searchCondition.searchCondition + "&deviceName=" + searchCondition.deviceName + "&beginIndex=" + searchCondition.beginIndex + "&deviceType=4");
    },
    onQueryRecordClick(data) {
      let searchCondition = this.editData.searchCondition;
      this.$router.push("/managePage/sendRecord?primaryDeviceNo=" + data + "&searchCondition=" + searchCondition.searchCondition + "&deviceName=" + searchCondition.deviceName + "&beginIndex=" + searchCondition.beginIndex + "&deviceType=4");
    },
    onQueryReasonClick(data) {
      let searchCondition = this.editData.searchCondition;
      this.$router.push("/managePage/stopReason?primaryDeviceNo=" + data + "&searchCondition=" + searchCondition.searchCondition + "&deviceName=" + searchCondition.deviceName + "&beginIndex=" + searchCondition.beginIndex);
    },
    onDevicePowerOnClick(primaryDeviceNo) {
      let self = this;
      let operate = 1;
      this.$confirm('是否确定通电?', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        self.operateDevice(primaryDeviceNo, operate);
      }).catch(action => {
      });
    },
    onDevicePowerOffClick(primaryDeviceNo) {
      let self = this;
      let operate = 2;
      this.$confirm('是否确定断电?', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        self.operateDevice(primaryDeviceNo, operate);
      }).catch(action => {
      });
    },
    operateDevice(primaryDeviceNo, operate) {
      let self = this;
      let params = {
        primaryDeviceNo: primaryDeviceNo,
        operate: operate
      }
      this.$http.post('/managementPlatform/electricity/operate', this.$qs.stringify(params)
      ).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message,
            center: true
          });
          return;
        }
        self.$message({
          type: "success",
          message: "操作成功!",
          center: true
        });
        self.deviceInfo.primaryDeviceChargeStatus = this.operateMap[operate];
      }).catch(function (response) {
        console.log(response);
      });
    },
    onOpenDoorClick(data) {
      let chargePortNo = data.chargePortNo;
      let operate = 3;
      let self = this;
      this.$confirm(data.chargePortSeqNo + '号柜门是否确定打开?', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        self.operateChargePort(chargePortNo, operate);
      }).catch(action => {
      });
    },
    onRefreshBtnClick(data) {
      this.queryChargeDetail();
    },
    onPowerOnBtnClick(data) {
      let chargePortNo = data.chargePortNo;
      let operate = 1;
      let self = this;
      this.$confirm('是否确定通电?', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        self.operateChargePort(chargePortNo, operate);
      }).catch(action => {
      });
    },
    onPowerOffBtnClick(data) {
      let chargePortNo = data.chargePortNo;
      let operate = 2;
      let self = this;
      this.$confirm('是否确定断电?', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        self.operateChargePort(chargePortNo, operate);
      }).catch(action => {
      });
    },
    operateChargePort(chargePortNo, operate) {
      let self = this;
      let params = {
        chargePortNo: chargePortNo,
        operate: operate
      }
      this.$http.post('/managementPlatform/electricity/operate', this.$qs.stringify(params)
      ).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message,
            center: true
          });
          return;
        }
        self.$message({
          type: "success",
          message: "操作成功!",
          center: true
        });
      }).catch(function (response) {
        console.log(response);
      });
    },
  },
}
</script>
<style lang="scss" scoped>
.list {
  line-height: 30px;
  margin: 0 30px;
  overflow: hidden;

  .name-label {
    float: left;
  }

  .value-label {
    float: left;
    width: 17%;
    max-width: 17%;
    height: 30px;
  }

  .date-global {
    width: 185px;
  }

  .list-input {
    width: 180px;
  }

  .blue-btn {
    margin-bottom: 10px;
  }
}

.table-custom {
  overflow-x: scroll;

  .text-btn {
    width: 50px;
    height: 24px;
    line-height: 24px;
    color: #417505;
    display: inline-block;
    background-color: #BEE6B3;
    cursor: pointer;
  }

  .fixed-width-75 {
    width: 75px;
  }

  .fixed-width-120 {
    width: 120px;
  }

  .fixed-width-60 {
    width: 60px;
  }
}

.ml-40 {
  margin-left: 40px;
}

.mt4 {
  margin-top: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/deviceMgmt/chargeCabinetMgmtDetailView.vue